import {Column} from 'react-table'
import {CertificateDetailsCell} from './CertificateDetailsCell'
import {CertificateCoCNumberCell} from './CertificateCoCNumberCell'
import {SearchCertificateModel} from '../../core/_models'

import { useMemo } from 'react'

export const useSearchCertificatesColumns = (): Column<SearchCertificateModel>[] => {

  return useMemo(() => [
    {
      Header: 'CoC Number',
      minWidth: 125,
      id:'cocNumber',
      Cell: ({...props}) => <CertificateCoCNumberCell data={props.data[props.row.index]} />,
    },
    {
      Header: 'Details',
      minWidth: 125,
      id:'details',
      Cell: ({...props}) => <CertificateDetailsCell data={props.data[props.row.index]} />,    
    },  
  ], [])
}

